import { Tooltip } from '@mui/material';
import React from 'react'

function HeaderTooltip({ title, children }) {
    return (
        <Tooltip
          title={title}
          placement="bottom-end"
          followCursor
          componentsProps={{
            tooltip: {
              sx: {
                bgcolor: "#ffffff",
                "box-shadow": "0px 4px 7px 0px #0000001C",
                color: "#8E93AF",
                "font-size": "16px",
                "line-height": "23px",
                "border-radius": "10px",
                fontFamily: "Montserrat",
                fontWeight: 400,
                padding: "6px 15px",
                "& .MuiTooltip-arrow": {
                  color: "#8E93AF",
                },
              },
            },
          }}
        >
          {children}
        </Tooltip>
      );
}

export default HeaderTooltip
